/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, ENAX){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="./common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="./common/svg/sprite.svg#arrow_right" /></svg></button>';

	const mainSlider = () => {
		if($('.js-mainSlider').length) {
			$('.js-mainSlider').slick({
				infinite: true,
				speed: 1000,
				autoplay: true,
				pauseOnHover: false,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				fade: true,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
			});
		}
	}

	// ====================================================
	mainSlider();

})(window.jQuery, window.ENAX);
